import React from "react";
import { Outlet } from "react-router-dom";

const Labs = (props) => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Labs;
